module.exports = __webpack_public_path__ + "media/12-3.2c931bed.mp3";